// Item 17: normalise Indian phones for links. 10-digit → 91XXXXXXXXXX; keep existing 91/+91.
export function normPhone(raw) {
  const d = String(raw || "").replace(/\D/g, "");
  if (d.length === 10 && /^[6-9]/.test(d)) return `91${d}`;
  if (d.length === 12 && d.startsWith("91")) return d;
  if (d.length === 11 && d.startsWith("0")) return `91${d.slice(1)}`;
  return null;
}
export const telLink = (raw) => { const p = normPhone(raw); return p ? `tel:+${p}` : null; };
export const waDmLink = (raw) => { const p = normPhone(raw); return p ? `https://wa.me/${p}` : null; };

export function relTime(iso) {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  const d = Math.floor(s / 86400);
  return `${d} day${d === 1 ? "" : "s"} ago`;
}
